module.exports = __webpack_public_path__ + "static/media/male-health-worker_1f468-200d-2695-fe0f-2.bda1d8be.png";